import styled, { css } from 'styled-components'

export const StyledOpenRightDrawer = styled.div`
  padding: 90px 20px 30px;
  color: #ffffff;
  text-overflow: clip;
  white-space: nowrap;

  .drawer-close {
    color: #000000;
  }

  @media (max-width: 960px), screen and (max-height: 540px) {
    padding-top: 60px;
    padding-bottom: 20px;
  }
`

export const StyledMenuList = styled.div`
  width: 100%;
`

export const StyledMenuListItem = styled.div`
  display: flex;
  flex-wrap: nowrap;
  margin-bottom: 35px;
  font-size: 24px;
  font-weight: bold;
  align-items: center;
  user-select: none;
  color: inherit;
  line-height: 1;
  cursor: pointer;
  font-family: 'Verizon-Bold';
  white-space: nowrap;

  &:last-child {
    margin-bottom: 0;
  }

  @media (max-width: 960px), screen and (max-height: 540px) {
    font-size: 16px;
    margin-bottom: 16px;
  }
`

interface MenuListIconProps {
  drawerOpen?: boolean
}

export const StyledMenuListIcon = styled.div<MenuListIconProps>`
  display: flex;
  width: 25px;
  justify-content: center;
  ${props =>
    props.drawerOpen &&
    css`
      margin-right: 19px;
    `}

  @media (max-width: 960px), screen and (max-height: 540px) {
    width: 20px;
    margin-right: 18px;
  }
`
